<script setup lang="ts">
interface SceneMeasureOption {
  value: string
  label: string
  detail: string
}

withDefaults(
  defineProps<{
    title?: string
    subtitle?: string
    activeLabel: string
    options: SceneMeasureOption[]
    activeValue: string
    active: boolean
    clearDisabled?: boolean
    clearLabel?: string
    note?: string
  }>(),
  {
    title: '测量工具',
    subtitle: '距离、高度、圆、方位角、角度、面积',
    clearDisabled: false,
    clearLabel: '清空测量结果',
    note: '',
  },
)

const emit = defineEmits<{
  (event: 'select', value: string): void
  (event: 'clear'): void
}>()
</script>

<template>
  <details class="panel-subsection" open>
    <summary class="panel-subsection-summary">
      <span class="summary-main">
        <span class="panel-subsection-title">{{ title }}</span>
        <span class="panel-section-subtitle">{{ subtitle }}</span>
      </span>
      <span class="summary-side">
        <span class="card-badge">{{ activeLabel }}</span>
        <span class="summary-chevron" aria-hidden="true">›</span>
      </span>
    </summary>

    <div class="panel-subsection-body">
      <div class="button-grid">
        <button
          v-for="item in options"
          :key="item.value"
          class="panel-button"
          :class="{ active: active && activeValue === item.value }"
          @click="emit('select', item.value)"
        >
          <span class="panel-button-label">{{ item.label }}</span>
          <span class="panel-button-meta">{{ item.detail }}</span>
        </button>
      </div>

      <p v-if="note" class="panel-note measure-note">{{ note }}</p>

      <button
        class="panel-button panel-button-wide panel-button-subtle measure-clear"
        :disabled="clearDisabled"
        @click="emit('clear')"
      >
        {{ clearLabel }}
      </button>
    </div>
  </details>
</template>

<style scoped>
.measure-note,
.measure-clear {
  margin-top: 10px;
}
</style>
